import React, { useRef } from 'react';
import { Container } from 'react-bootstrap';
// import './ContactMe.css';

import emailjs from 'emailjs-com'; // Import emailjs library
import {
 
  FaEnvelope,
  FaFlag,
  FaGithub,
  FaLinkedin,
  FaMailBulk,
  FaMap,
  FaSlack,
  FaStar,
 
} from "react-icons/fa";
const ContactMe = () => {
  const form = useRef();
      const sendEmail = (e) => {
        e.preventDefault();

        emailjs
            .sendForm(
                            "service_dwlfr88",
                "template_ofs30zl",
                form.current,
                "I_VQHoH4MPQYZQhyL"   
            )
            .then(
                (result) => {
                    console.log(result.text);
                    console.log("message sent");
                    // You can add additional handling here, such as showing a success message to the user
                },
                (error) => {
                    console.log(error.text);
                    // You can add additional handling here, such as showing an error message to the user
                }
            );

        // Clear the form after sending email
        form.current.reset();
    };

  const iconStyle={
    // backgroundColor: "var(--secondary)",
              fontSize: "20px",
              fontWeight: "800",
              color: "var(--secondary)",
              border: "2px solid var(--secondary)",
              borderRadius:"20%",
              margin:"0 1px",
              padding:"8px 10px"
             
  }
  const infoContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
    gap: '13px',  // Adds space between icon and text
  };

  const iconStyle2 = {
    color: 'var(--secondary)',  // Blue color, adjust as needed
    fontSize: '20px',  // Adjust size of the icon
  };

  const textStyle = {
    margin: 0,
    fontSize: '16px',
    color: '#333',  // Dark gray color for the text
    textDecoration: 'none', // Remove default link styling
  };

  const linkStyle = {
    display: 'flex',
    alignItems: 'center',
    color: 'inherit', // Use parent color to inherit the text color
    textDecoration: 'none', // Remove underline from the link
  };
  return (
    <Container className="contactme">
     
        <div className="form">
          <div className="contact-form">
            <form ref={form}  onSubmit={sendEmail}>
              <h3 className="title">Contact Us</h3>
              <div className="input-container">
                <input type="text" name="name" className="input" placeholder="Name"/>
                {/* <label htmlFor="name">Name</label> */}
                <span>Name</span>
              </div>
              <div className="input-container">
                <input type="email" name="email" className="input" placeholder="Email" />
                {/* <label htmlFor="email">Email</label> */}
                <span>Email</span>
              </div>
              <div className="input-container">
                <textarea name="message" className="input" placeholder="Message"></textarea>
                {/* <label htmlFor="message">Message</label> */}
                <span>Message</span>
              </div>
              <button type="submit" className="btn">Send</button>
            </form>
          </div>
          <div className="contact-info">
            <h3 className="title">Get in touch</h3>
            <p className="text">You can contact us via the form or through the following channels:</p>
            <div className="information" style={infoContainerStyle}>
      <FaFlag style={iconStyle2} />
          <p style={textStyle}> Pakistan</p>
    
      </div>
      <div className="information" style={infoContainerStyle}>
        <FaEnvelope style={iconStyle2} />
        <p style={textStyle}>kashafabdullah01@gmail.com</p>
      </div>
      <div className="information" style={infoContainerStyle}>
        <FaLinkedin style={iconStyle2} />
        <p style={textStyle}>Kashaf Abdullah</p>
      </div>
            <div className="social-media">
              <p>Follow us on:</p>
              <div className="logo-social-media" style={{ margin: "1rem 0" }}>
        
        <a className='button-85' href="https://www.linkedin.com/in/sajahkhan" target="_blank" rel="noopener noreferrer"  style={iconStyle}>
              <FaLinkedin style={{position:"relative",bottom:"2px"}}/>
            </a>
        
            <a className='button-85' href="https://github.com/Kashaf-Abdullah/" target="_blank" rel="noopener noreferrer"  style={iconStyle}>
              <FaGithub style={{position:"relative",bottom:"2px"}}/>
            </a>
        
            <a className='button-85' href="mailto: kashafabdullah01@gmail.com" target="_blank" rel="noopener noreferrer"  style={iconStyle}>
              <FaMailBulk style={{position:"relative",bottom:"2px"}}/>
            </a>
        
        
            <a className='button-85' href="" target="_blank" rel="noopener noreferrer"  style={iconStyle}>
              <FaSlack style={{position:"relative",bottom:"2px"}}/>
            </a>
          
                 </div>
               
            </div>
          </div>
        </div>
    
    </Container>
  );
}

export default ContactMe;